// extracted by mini-css-extract-plugin
export default {"submitButton":"Form_submitButton__nBD-r"};